import en from "./en.json";
import nl from "./nl.json";
import de from "./de.json";
import fr from "./fr.json";
import es from "./es.json";
import it from "./it.json";
import pt from "./pt.json";
import { loadPageTranslations } from "../../loadPageTranslations";

const files = { en, nl, de, fr, es, it, pt };

export function getBusinessPageTranslations(lang: string): Record<string, string> {
	return loadPageTranslations(files, lang);
}
